import React, { useEffect, useState } from 'react'
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';

// Components
import Modal from '../../ui/modal/Modal';
import Button from '../../atoms/button/button';

// Styles //
import './SelectRecommendedTopics.scss'

const SelectRecommendedTopics = (props) => {

  const {
    tituloBotonTerminos,
    inputPrincipal,
    listaSelect,
    textoTerminos
  } = props.referenciaFormulario;

  const [modalValues, setModalValues] = useState({});

  const saveTopics = () => {
    localStorage.setItem("hashSection", "destacadosDeTuInteresRef")
    for (const topic in modalValues) {
      if (modalValues[topic] === true)
        localStorage.setItem(topic, 'true')

      if (modalValues[topic] === false)
        localStorage.removeItem(topic)
    }
    localStorage.setItem("hashSection", "destacadosDeTuInteresEmpresas")
    props.closeModal()
  };


  // Obtiene los temas seleccionados del local storage y los inyecta al estado
  useEffect(() => {
    if (listaSelect)
      listaSelect.map((topic) => {
        if (localStorage.getItem(topic))
          setModalValues((prev) => {
            return { ...prev, [topic]: 'true' };
          })
      })
  }, [])

  return (
    <>
      {<Modal showModal={props.displayModal} onClose={props.closeModal}>
        <div className='m-select-recommended-topics'>
          <div className="m-select-recommended-topics-title">
            <h3>{inputPrincipal}</h3>
          </div>
          <div className="m-select-recommended-topics-text">
            <p>{textoTerminos && contentfulRenderOptions(textoTerminos.content[0].content[0])}</p>
          </div>
          <div className="m-select-recommended-topics-options">
            {listaSelect && listaSelect.map((topic) => {
              return <>
                <label className='m-select-recommended-topics-options-label'>
                  <input
                    type="checkbox"
                    value={topic}
                    checked={modalValues[topic] ? true : false}
                    onChange={(e) => setModalValues((prev) => {
                      return { ...prev, [e.target.value]: e.target.checked };
                    })}
                  />
                  <span>{topic}</span>
                </label>

              </>
            })}
          </div>
          <div className="m-select-recommended-topics-button">
            <Button type={'link'} classname={'a-button__magenta'} text={tituloBotonTerminos} onClickAction={saveTopics} isDisabled={false} href='' />
          </div>
        </div >
      </Modal >}
    </>
  )
}

export default SelectRecommendedTopics